import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestCancellationService {
  private cancelPendingRequests$ = new Subject<void>();

  constructor() { }

  get onCancelRequests() {
    return this.cancelPendingRequests$.asObservable();
  }

  cancelAllRequests() {
    this.cancelPendingRequests$.next();
  }
}